import { cn } from "@/lib/tailwind"
import type * as React from "react"

interface Props extends Omit<React.HTMLAttributes<HTMLDivElement>, "content"> {
  content?: string | null
}

export function EditorContent({ content, ...props }: Props) {
  return (
    <div
      suppressHydrationWarning
      dangerouslySetInnerHTML={{ __html: content || "" }}
      {...props}
      className={cn(
        "w-full text-black dark:text-white [&_a]:font-semibold [&_a]:text-black [&_a]:underline hover:[&_a]:opacity-75 dark:[&_a]:text-white [&_ol]:list-decimal [&_ol]:pl-6 [&_ul]:list-disc [&_ul]:pl-6",
        props.className,
      )}
    />
  )
}
